import { ReactNode } from 'react';

export interface RadioOption {
    value: string;
    label: ReactNode;
}

/**
 * Groupe de boutons radio — remplace antd Radio.Group / MUI RadioGroup.
 */
const RadioGroup = (props: {
    value?: string;
    onChange: (value: string) => void;
    options: RadioOption[];
    label?: ReactNode;
    disabled?: boolean;
    inline?: boolean;
    className?: string;
}) => (
    <div className={props.className}>
        {props.label && (
            <label className="block text-xs font-semibold text-[var(--eb-text-muted)] mb-1.5">{props.label}</label>
        )}
        <div className={`flex gap-4 ${props.inline !== false ? 'flex-row flex-wrap' : 'flex-col'}`}>
            {props.options.map(opt => (
                <label key={opt.value} className={`inline-flex items-center gap-2 select-none ${props.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}>
                    <input
                        type="radio"
                        checked={props.value === opt.value}
                        disabled={props.disabled}
                        onChange={() => props.onChange(opt.value)}
                        className="w-4 h-4 accent-[var(--eb-primary)] cursor-pointer disabled:cursor-not-allowed"
                    />
                    <span className="text-sm text-[var(--eb-text)]">{opt.label}</span>
                </label>
            ))}
        </div>
    </div>
);

export default RadioGroup;
